import { render, staticRenderFns } from "./BagsTable.vue?vue&type=template&id=26221efa"
import script from "./BagsTable.vue?vue&type=script&lang=js"
export * from "./BagsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports